import { jsx as _jsx } from "react/jsx-runtime";
// change 200x47 to 99X48 when pf logo is changed to a smaller one.
const dimensions = {
    vf: { width: '99', height: '48' },
    pf: { width: '132', height: '48' },
    medewerkersportaal: { height: '48' },
    vfpf: { width: '200', height: '48' },
    ssa: { height: '48' },
};
const ALT_TEKST = {
    pf: 'Logo Participatiefonds',
    vf: 'Logo Vervangingsfonds',
    vfpf: 'Logo VfPf',
    medewerkersportaal: 'Logo VfPf Medewerkersportaal',
    ssa: 'Logo VfPf'
};
const ImageSource = {
    ssa: "/ssa/assets/img/logo.svg",
    pf: "/assets/img/logo.svg",
    vf: "/assets/img/logo.svg",
    vfpf: "/assets/img/logo.svg",
    medewerkersportaal: "/assets/img/logo.svg",
};
export const Brand = props => (_jsx("img", Object.assign({ src: ImageSource[props.variant] }, dimensions[props.variant], { alt: ALT_TEKST[props.variant] })));
